module.exports = __webpack_public_path__ + "media/images/icons/filled/smile-64b81da0005371a3fed944ec3ff0c617.svg";